export const loadStoredApplication = () => {
  if (localStorage.getItem("newCase")){
    return JSON.parse(localStorage.getItem("newCase")!)
  }
  return {};
}